(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/services/leia-games.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/services/leia-games.js');
"use strict";


const fetchLEIAGames = async () => {
  try {
    const path = "".concat(svs.core.urlMapping.get('ticketsApi'), "/tickets-catalog");
    const response = await fetch("".concat(window.location.origin).concat(path));
    if (!response.ok) {
      throw new Error('Failed to fetch games from LEIA');
    }
    const data = await response.json();
    return data.map(svs.ticketgames.gameHandler.helpers.mapLeiaGames);
  } catch (err) {
    return [];
  }
};
setGlobal('svs.eInstant.shared.services', {
  fetchLEIAGames
});

 })(window);